import { getCurrencyForApi } from '~/helpers/configuration-utils';

// eslint-disable-next-line func-names
export default function(context) {
  const {
    app: { $vsf }
  } = context;

  const currency = getCurrencyForApi(context);
  $vsf.$sapcc.client.interceptors.request.use((config) => {
    const requestObj = config.data?.[0];
    if (requestObj && typeof requestObj === 'object' && !requestObj.currency) {
      config.data[0].currency = currency;
    }

    return config;
  });

  return true;
}
